import { useState, useEffect } from 'react';

const SECTIONS = [
    { id: 'top', label: 'Top' },
    { id: 'in-one-line', label: 'In one line' },
    { id: 'concept', label: 'Why it matters' },
    { id: 'capture', label: 'What we capture' },
    { id: 'how-it-works', label: 'How it works' },
    { id: 'moments', label: 'Every departure' },
    { id: 'deliverables', label: 'What they keep' },
    { id: 'ask-the-role', label: 'Ask the role' },
    { id: 'case-study', label: 'Case study' },
    { id: 'savings', label: 'ROI' },
    { id: 'pricing', label: 'Pricing' },
    { id: 'faq', label: 'FAQ' },
];

export const SectionRail = () => {
    const [active, setActive] = useState('top');
    useEffect(() => {
        const els = SECTIONS.map((s) => document.getElementById(s.id)).filter(Boolean) as HTMLElement[];
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) setActive(e.target.id);
                });
            },
            { rootMargin: '-45% 0px -50% 0px', threshold: 0 }
        );
        els.forEach((el) => obs.observe(el));
        return () => obs.disconnect();
    }, []);

    return (
        <div className="fixed right-6 top-1/2 -translate-y-1/2 z-40 hidden xl:flex flex-col gap-2">
            {SECTIONS.map((s) => (
                <a key={s.id} href={`#${s.id}`} className="group flex items-center gap-2.5 justify-end" aria-label={`Jump to ${s.label}`}>
                    <span
                        className={`text-[11px] font-medium transition-all ${
                            active === s.id ? 'text-foreground opacity-100' : 'text-muted-foreground opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0'
                        }`}
                    >
                        {s.label}
                    </span>
                    <span className={`block rounded-full transition-all ${active === s.id ? 'w-2.5 h-2.5 bg-primary' : 'w-1.5 h-1.5 bg-border group-hover:bg-muted-foreground'}`} />
                </a>
            ))}
        </div>
    );
};
